import { FunctionComponent, useMemo, CSSProperties } from 'react';
import styles from './SpinResult.module.css';
import { useMedia } from '@pp/core';
export interface ResultProp {
  id?: string;
  shouldGlow?: boolean;
  className?: string;
  multiplier?: number;
  isMulti?: boolean;
  text: string | undefined;
  mods: string;
  typeClass: string | undefined;
  handleRelease(text: any): void;
  handleOnMouseOver(number: number, mouseLeave: boolean): void;
  hoverActiveNumber: number;
}

export const RecentResult: FunctionComponent<ResultProp> = ({
  id,
  shouldGlow,
  className,
  multiplier,
  isMulti,
  typeClass,
  text,
  mods,
  handleRelease,
  handleOnMouseOver,
  hoverActiveNumber,
}) => {
  const isExtraWideWidth = useMedia('(min-width: 1512px)');
  const multiplierHeight = useMemo(() => {
    return isExtraWideWidth ? 16 : 13;
  }, [isExtraWideWidth]);

  let glowStyle = "";
  if (shouldGlow) {
    glowStyle = styles.borderOnHover;
  } else if (hoverActiveNumber > 0) {
    glowStyle = styles.hideBorder;
  }

  return (
    <div
      data-test-id={id}
      className={styles.footer_Inline}
      onPointerUp={() => handleRelease(text)}
      onMouseEnter={() => handleOnMouseOver(Number(text), false)}
      onMouseLeave={() => handleOnMouseOver(Number(text), true)}
    >
      <div className={styles.recentResultValue + ' ' + mods}>
        {isMulti && multiplier && (
          <div
            className={styles.multiplier}
            style={{ '--mulptiplierHeight': `${multiplierHeight}px` } as CSSProperties}
          >
            <div className={styles.multiplierValue}>{multiplier + 'x'}</div>
          </div>
        )}
        <div
          className={[styles.circle, styles.outer_circle, styles.glowRecentResult, glowStyle].join(' ')}
          style={{ '--borderColor': `var(--game-traffic-light-mw_${typeClass})` } as CSSProperties}
        >
          <div className={[styles.recentResultDiv, styles.type, styles.active, className].join(' ')}>
            <div className={styles.number}>{text}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
